<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            values: values.$ | async
        } as data"
    >
        <div
            class="bazis-dropdown"
            clickOutside
            (clickOutside)="hideList()"
            [excludeElement]="toggleBtn"
        >
            <bazis-button
                #toggleBtn
                fill="clear"
                class="bazis-dropdown__trigger"
                (click)="toggleList()"
            >
                <ng-container *ngIf="data.values.length; else tplNoSelected">
                    <ng-container *ngFor="let value of data.values; let i = index">
                        <ng-container
                            *ngIf="searchSettings.entityType !== 'organization.organization_info'"
                        >
                            <ng-container
                                *ngIf="value | entity : searchSettings.entityType | async as entity"
                            >
                                <bazis-autocomplete-selected-value
                                    [infiniteListTpl]="infiniteListTpl"
                                    [entity]="entity"
                                    [valuesLength]="values._.length"
                                    [index]="i"
                                ></bazis-autocomplete-selected-value>
                            </ng-container>
                        </ng-container>
                        <ng-container
                            *ngIf="searchSettings.entityType === 'organization.organization_info'"
                        >
                            <ng-container *ngIf="value | organization | async as entity">
                                <bazis-autocomplete-selected-value
                                    [infiniteListTpl]="infiniteListTpl"
                                    [entity]="entity"
                                    [entityNameField]="nameField"
                                    [valuesLength]="values._.length"
                                    [index]="i"
                                ></bazis-autocomplete-selected-value>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <ng-template #tplNoSelected>
                    {{ t(emptySelectedKey || 'title.search') }}
                </ng-template>

                <bazis-icon
                    [name]="icons.angleDown"
                    size="regular"
                    slot="end"
                ></bazis-icon>
            </bazis-button>

            <div
                class="bazis-dropdown__body"
                *ngIf="showList"
            >
                <bazis-input-default
                    [formControl]="searchControl"
                    [noteKey]="noteKey"
                    [tooltipKey]="tooltipKey"
                    [noteParams]="noteParams"
                    [tooltipParams]="tooltipParams"
                    [tooltipSettings]="tooltipSettings"
                    [placeholderKey]="placeholderKey"
                    [hasEraser]="false"
                    [sizeControl]="sizeControl"
                    [required$]="required$"
                    (touched)="markAsTouched()"
                ></bazis-input-default>

                <bazis-infinite-list
                    [searchSettings]="searchSettings"
                    [emptyValue]="emptyValueEntity"
                    [excludeIds$]="excludeIds$"
                    emptyListKey="title.emptySearch"
                    [search$]="searchControl.valueChanges"
                >
                    <ng-template let-item="item">
                        <div
                            class="bazis-item"
                            [class.bazis-item--selected]="
                                valuesMap &&
                                valuesMap.has(
                                    searchSettings.fieldForId
                                        ? item.$snapshot[searchSettings.fieldForId]?.id
                                        : item.id
                                )
                            "
                            (click)="
                                toggleValue(
                                    searchSettings.fieldForId
                                        ? item.$snapshot[searchSettings.fieldForId]?.id
                                        : item.id
                                )
                            "
                        >
                            <ng-container
                                *ngIf="infiniteListTpl"
                                [ngTemplateOutlet]="infiniteListTpl"
                                [ngTemplateOutletContext]="{ item: item }"
                            ></ng-container>
                            <ng-container *ngIf="!infiniteListTpl">
                                {{
                                    item.$snapshot.name ||
                                        item.$snapshot[nameField] ||
                                        t(item.$snapshot.nameKey)
                                }}
                            </ng-container>
                        </div>
                    </ng-template>
                </bazis-infinite-list>
            </div>
        </div>
    </ng-container>
</ng-container>
